import BaseAction from './BaseAction.js';

class BaseParameterAction extends BaseAction {
    serialize(action, id) {
        let json = super.serialize(action, id);
        let {operation} = json;
        let {payload} = operation;
        if (payload.parameter) {
            //payload.parameter = payload.parameter.getJson();
            let {id, context, name} = payload.parameter;
            payload.parameter = {
                id,
                context: context && context.getJson(),
                name
            };
        }

        if (payload.automation) {
            let {parameter} = payload.automation;
            if (parameter) {
                payload.parameter = parameter.getJson();
            }
            payload.automation = payload.automation.id;
        }

        return json;
    }

    deserialize(json) {
        let action = super.deserialize(json);
        let {payload} = action;
        let {id, name, context} = payload.parameter;

        if (context.track !== undefined) {
            payload.track = this.sequencerEngine.tracks[context.track];
        }

        if (context.subTrack !== undefined) {
            payload.track = payload.track.tracks[context.subTrack].track;
        }

        if (context.midiEffect !== undefined) {
            if (payload.track) {
                let effect = payload.track.midiEffects.effects[context.midiEffect];
                let parameter = effect.parameters.find(p => p.name === name);
                if (parameter) {
                    payload.parameter = parameter;
                } else {
                    payload.parameter = undefined;
                }
            }
        } else if (context.effect !== undefined && context.effect !== -1) {
            if (payload.track) {
                let track = payload.track;
                let effect = track.effects[context.effect];
                if (context.subDevice) {
                    effect = effect.getSubDevice(context.subDevice);
                }
                if (context.macro) {
                    effect = effect.macros.find(m => m.id === context.macro);
                }
                let parameter = effect.getParameters().find(p => p.name === name);
                if (parameter) {
                    payload.parameter = parameter;
                } else {
                    payload.parameter = undefined;
                }
            }
        } else if (context.isInstrument) { 
            payload.instrument = payload.track.instrument;
            if (context.subDevice) {
                let subDevice = payload.instrument.getSubDevice(context.subDevice);
                payload.parameter = subDevice.parameters.find(
                    p => p.name  === name);
            } else {
                payload.parameter = payload.instrument.parameters.find(
                    p => p.name  === name);
            }
        } else { 
            payload.parameter = undefined;
        }

        if (payload.automation && payload.parameter) {
            // TODO: find the automation this refers to
            // for now just choose unlockedAutomation 
            payload.automation = payload.parameter.unlockedAutomation;
        }

        return action;
    }

    getContentId({payload}) {
        if (payload.point) {
            return payload.point.id;
        }
        
        if (payload.parameter) {
            return payload.parameter.id;
        }

        return 0;
    }
}

export default BaseParameterAction;
